export default __webpack_public_path__ + "static/media/oasis_logo.e723d0f6.svg";